import { canLogPostAction } from "./accountTypes";

export function getActionSummaryLabel(actionCount, hasLogged) {
  if (actionCount <= 0) return null;
  if (hasLogged) {
    if (actionCount === 1) return "You took action";
    const others = actionCount - 1;
    return others === 1 ? "You and 1 other" : `You and ${others} others`;
  }
  return actionCount === 1 ? "1 took action" : `${actionCount} took action`;
}

export function getActionSummaryAccessibilityLabel(actionCount, hasLogged) {
  if (actionCount <= 0) return "";
  if (hasLogged) {
    if (actionCount === 1) return "You took action, view list";
    const others = actionCount - 1;
    const othersLabel = others === 1 ? "1 other person" : `${others} other people`;
    return `You and ${othersLabel} took action, view list`;
  }
  const peopleLabel = actionCount === 1 ? "1 person" : `${actionCount} people`;
  return `${peopleLabel} took action, view list`;
}

export function getDisplayActionCount({ verifiedCountsOnly, actionCount, verifiedActionCount }) {
  return verifiedCountsOnly ? verifiedActionCount : actionCount;
}

/**
 * Pure state reducer for optimistic toggle updates.
 */
export function computeToggledActionCounts({
  logged,
  serverCount,
  serverVerifiedCount,
  fallbackDelta,
  prevActionCount,
  prevVerifiedActionCount,
  isVerified,
}) {
  const actionCount =
    typeof serverCount === "number" ? serverCount : Math.max(0, prevActionCount + fallbackDelta);
  const verifiedActionCount =
    typeof serverVerifiedCount === "number"
      ? serverVerifiedCount
      : isVerified
        ? Math.max(0, prevVerifiedActionCount + fallbackDelta)
        : prevVerifiedActionCount;

  return { logged, actionCount, verifiedActionCount, delta: fallbackDelta };
}

export function resolveToggleErrorCode(error) {
  return error?.response?.data?.code ?? null;
}

export function getToggleFallbackFromErrorCode(code) {
  if (code === "already_logged") {
    return { logged: true, serverCount: undefined, serverVerifiedCount: undefined, delta: 0 };
  }
  if (code === "not_logged") {
    return { logged: false, serverCount: undefined, serverVerifiedCount: undefined, delta: 0 };
  }
  return null;
}

export function shouldShowActionRow({ post, isAuthor, displayActionCount }) {
  const showToggleButton = !isAuthor && canLogPostAction(post);
  return showToggleButton || displayActionCount > 0;
}

export function shouldShowActionToggle({ post, isAuthor }) {
  return !isAuthor && canLogPostAction(post);
}

export function getActionUserDisplayName(user) {
  if (user?.first_name && user?.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user?.username || "Anonymous";
}

export function getActionUserInitials(user) {
  const name = user?.first_name || user?.username || "?";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}
